import React from "react";

// const Input = ({
//   type,
//   name,
//   label,
//   value,
//   help,
//   error,
//   onChange,
//   autoFocus
// }) => {
const Input = ({name, label, error, help, table, ...rest}) => {
    return (
        <div className={table ? "" : "form-group"}>
            {label && <label htmlFor={name}>{label}</label>}
            <input name={name} id={name} {...rest} className="form-control"/>
            {help && (
                <small id={`${name}Help`} className="form-text text-muted">
                    {help}
                </small>
            )}
            {error && <div className="alert alert-danger">{error}</div>}
        </div>
    );
};

export default Input;

/* <input
        id={name}
        name={name}
        value={value}
        type={type}
        autoFocus={autoFocus}
        onChange={onChange}
        className="form-control"
      /> */
